import React, { useEffect, useRef, useState } from "react";

import { CircularIndeterminate, FormButton } from "components";
import { FormikSelectInput, FormikTextInput } from "components/UI/Inputs/FormikInputs";

import { Form, Formik } from "formik";
import * as yup from "yup";

import { useRecoilValue, useSetRecoilState } from "recoil";
import { rowSelected, snackbarData, userCredentials } from "recoilState/GlobalState";

import { FORM_ERROR_MESSAGES } from "consts/errorMessages";

import styles from "styles/pages/ModalActions.module.scss";
import { handleResponse } from "services/Local-services";
import { horarioGet, usuarioLugarHorarioIns } from "services/services-mia/miakey";
import { Grid } from "@mui/material";

const FECHA_HOY = new Date().toISOString().substring(0, 10);

export default function InsertModal({
    usuarioId,
    merchantServicioUsuarioId,
    gateZonaId,
    gateLugarId,
    zonaNombre,
    lugarNombre,
    usuarioNombre,
    updateList,
    closeModal,
}) {
    const [inRequest, setInRequest] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [horarios, setHorarios] = useState([]);

    const setSelected = useSetRecoilState(rowSelected);
    const setSnackbarInfo = useSetRecoilState(snackbarData);
    const credentials = useRecoilValue(userCredentials);

    const formikRef = useRef();

    useEffect(() => {
        const fetchData = async () => {
            setIsLoading(true);
            const { result } = await horarioGet({}, credentials);
            setHorarios(result);
            if (result[0]?.gateHorarioId && formikRef.current) {
                formikRef.current.setFieldValue("horario", result[0].gateHorarioId);
            }
            setIsLoading(false);
        };
        fetchData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [credentials]);

    const handleSubmit = async ({ horario, estado, fecha }) => {
        setInRequest(true);

        const response = await usuarioLugarHorarioIns({
            usuarioId,
            merchantServicioUsuarioId,
            gateZonaId,
            gateLugarId,
            gateHorarioId: Number(horario),
            gateUsuarioLugarHorarioStatus: estado,
            gateUsuarioLugarHorarioFH: fecha,
        }, credentials);

        handleResponse(
            response,
            "Estado agregado exitosamente",
            { setSnackbarInfo, setIsOpen: closeModal, setSelected, updateList }
        );

        setInRequest(false);
    };

    return (
        <Formik
            key={[gateZonaId, gateLugarId, usuarioId].join("-")}
            innerRef={formikRef}
            initialValues={{
                horario: "",
                estado: "A",
                fecha: FECHA_HOY,
            }}
            validationSchema={yup.object({
                horario: yup.string(FORM_ERROR_MESSAGES.text).required(FORM_ERROR_MESSAGES.required),
                estado: yup.string(FORM_ERROR_MESSAGES.text).required(FORM_ERROR_MESSAGES.required),
                fecha: yup.string(FORM_ERROR_MESSAGES.text).required(FORM_ERROR_MESSAGES.required),
            })}
            onSubmit={(values, { setSubmitting }) => {
                try {
                    handleSubmit(values);
                } catch (e) {
                    setSnackbarInfo({ message: e.errmsg, severity: "error", open: true });
                } finally {
                    setSubmitting(false);
                }
            }}
        >
            <Form className={styles.inputs} noValidate>
                <Grid container justifyContent={"center"} spacing={2}>
                    <Grid item xs={12} md={4}>
                        <FormikTextInput
                            name="fecha"
                            labelText="Fecha"
                            type="date"
                            inputProps={{ min: FECHA_HOY }}
                        />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <FormikSelectInput name="horario" labelText="Horario">
                            {horarios.map((h) => (
                                <option key={h.gateHorarioId} value={h.gateHorarioId}>
                                    {h.gateHorarioNombre}
                                </option>
                            ))}
                        </FormikSelectInput>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <FormikSelectInput name="estado" labelText="Estado">
                            <option value="A">Alta</option>
                            <option value="B">Baja</option>
                        </FormikSelectInput>
                    </Grid>
                    <FormButton
                        inRequest={inRequest || isLoading}
                        newFormData={{ button: "Agregar" }}
                        onCloseModal={closeModal}
                    />
                    {(inRequest || isLoading) && <CircularIndeterminate />}
                </Grid>
            </Form>
        </Formik>
    );
}
